export { registerComponent as registerButtonComponent } from '../../components/builtin/Button/register'
export { default as Button } from '../../components/builtin/Button/Button'
